import { call, put, all, takeLatest } from "redux-saga/effects";
import { Api } from "../api";
import * as elementsActions from "../actions/elements";
import * as generalActions from "../actions/general";
import * as authActions from "../actions/auth";

const colors = [
  "#030303",
  "#0579DF",
  "#F32641",
  "#46A767",
  "#AA3E98",
  "#DFBE99",
  "#F80",
  "#1EBAC4",
  "#0000FF",
  "#40E0D0",
  "#5F9EA0",
]

function* getIncidentAging(action) {
  try {
    const res = yield call(Api.elements.getIncidentAging, action.payload);
    const max = Math.max(...res.data.data.slice(0, -1).map(item => item.total));
    yield put({
      type: elementsActions.GET_INCIDENT_AGING_SUCCESS,
      payload: {chart: res.data.data, max},
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_INCIDENT_AGING_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getIncidentResolution(action) {
  try {
    const res = yield call(Api.elements.getIncidentResolution, action.payload);
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getIncidentResolutionSummary(action) {
  try {
    const res = yield call(Api.elements.getIncidentResolutionSummary, action.payload);
    const closed = {
      labels: res.data.data.Closed.labels,
      datasets: res.data.data.Closed.data.map((item, i) => {
        return  {
          label: item.label,
          data: item.data,
          borderColor: colors[i],
          pointRadius: 0,
          borderWidth: 2
        }
      }),
    };
    const openCloseRateOptions = [
      {color: '#0579DF', backgroundColor: 'rgba(255, 136, 0, .1)', fill: true, borderWidth: 0},
      {color: '#030303', borderWidth: 2},
      {color: 'red', borderWidth: 0},
    ]
    const openCloseRate = {
      labels: res.data.data.OpenCloseRate.labels,
      datasets: res.data.data.OpenCloseRate.data.map((item, i) => {
        return  {
          label: item.label,
          data: item.data,
          borderColor: colors[i],
          pointRadius: 0,
          borderWidth: openCloseRateOptions[i].borderWidth,
          fill: openCloseRateOptions[i].fill,
          backgroundColor: openCloseRateOptions[i].backgroundColor,
        }
      }),
    };

    const planVsActualOptions = [
      {color: '#0579DF'},
      {color: '#030303'},
      {color: '#0579DF', borderDash: [10, 5]},
    ]
    const planVsActual = {
      labels: res.data.data.PlanVsActual.labels,
      datasets: res.data.data.PlanVsActual.data.map((item, i) => {
        return  {
          label: item.label,
          data: item.data,
          borderColor: planVsActualOptions[i].color,
          pointRadius: 0,
          borderWidth: 2,
          borderDash: planVsActualOptions[i].borderDash,
        }
      }),
    };
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_SUMMARY_SUCCESS,
      payload: {closed, openCloseRate, planVsActual},
    });
    const res2 = yield call(Api.general.getLastRefreshDate, action.payload);
    yield put({
      type: generalActions.GET_LAST_REFRESH_DATE_SUCCESS,
      payload: res2.data?.data.RefreshDate,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getIncidentResolutionFilterLookups(action) {
  try {
    const res = yield call(Api.elements.getIncidentResolutionFilterLookups, action.payload);
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getIncidentResolutionProgress(action) {
  try {
    const res = yield call(Api.elements.getIncidentResolutionProgress, action.payload);

    const openCloseTicketsOptions = [
      {type: 'line', borderColor: '#0579DF', pointBackgroundColor: '#fff', pointRadius: 4},
      {backgroundColor: '#F32641', pointRadius: 0},
      {backgroundColor: '#46A767', pointRadius: 0},
    ]
    
    const data = {
      labels: res.data.data.labels,
      datasets: res.data.data.data.map((item, i) => {
        return  {
          label: item.label,
          data: item.data,
          type: openCloseTicketsOptions[i]?.type,
          pointRadius: openCloseTicketsOptions[i]?.pointRadius,
          backgroundColor: openCloseTicketsOptions[i]?.backgroundColor,
          borderColor: openCloseTicketsOptions[i]?.borderColor,
          pointBackgroundColor: openCloseTicketsOptions[i]?.pointBackgroundColor,
        }
      }),
    };

    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_PROGRESS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_INCIDENT_RESOLUTION_PROGRESS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getOpenIncidentsTrend(action) {
  try {
    const res = yield call(Api.elements.getOpenIncidentsTrend, action.payload);
    yield put({
      type: elementsActions.GET_OPEN_INCIDENTS_TREND_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_OPEN_INCIDENTS_TREND_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getSLAFilterLookUps(action) {
  try {
    const res = yield call(Api.elements.getSLAFilterLookUps, action.payload);


    yield put({
      type: elementsActions.GET_SLA_FILTER_LOOKUPS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_SLA_FILTER_LOOKUPS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({});
  }
}

function* getSLADataSummary(action) {
  try {
    const res = yield call(Api.elements.getSLADataSummary, action.payload);
    yield put({
      type: elementsActions.GET_SLA_DATA_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementsActions.GET_SLA_DATA_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}




export default all([
  takeLatest(elementsActions.GET_INCIDENT_AGING_REQUEST, getIncidentAging),
  takeLatest(elementsActions.GET_INCIDENT_RESOLUTION_REQUEST, getIncidentResolution),
  takeLatest(elementsActions.GET_INCIDENT_RESOLUTION_SUMMARY_REQUEST, getIncidentResolutionSummary),
  takeLatest(elementsActions.GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_REQUEST, getIncidentResolutionFilterLookups),
  takeLatest(elementsActions.GET_INCIDENT_RESOLUTION_PROGRESS_REQUEST, getIncidentResolutionProgress),
  takeLatest(elementsActions.GET_OPEN_INCIDENTS_TREND_REQUEST, getOpenIncidentsTrend),
  takeLatest(elementsActions.GET_SLA_FILTER_LOOKUPS_REQUEST, getSLAFilterLookUps),
  takeLatest(elementsActions.GET_SLA_DATA_SUMMARY_REQUEST, getSLADataSummary),
  ]
);
